import { ComponentProps } from 'react';
import { clsx } from 'clsx';

export const ContentLayout = ({
  className,
  ...props
}: ComponentProps<'div'>) => {
  return (
    <div
      className={clsx(
        'relative my-0 flex h-full flex-1 grow flex-col justify-center p-4 sm:p-8',
        className,
      )}
      {...props}
    />
  );
};
